import { BudgetData } from 'types/api/budget.type';

import { TabWrap } from 'sections/TabWrap';

import { useData } from './Data.hooks';

export function Data({ data }: { data?: BudgetData }): React.ReactElement {
  const { sections } = useData(data);

  return <TabWrap sections={sections} />;
}
